module.exports = __webpack_public_path__ + "img/veloshop.ca_Mobile3__1551460672_76.67.188.141.9984ddf6.jpg";